export default __webpack_public_path__ + "5dba3755d4991ed0a3ab7e7c52a795ad.png";